import merge from 'lodash/merge';
import languages from '@/config/languages';

import InputText from '@/components/form/InputText.vue';
import InputTextarea from '@/components/form/InputTextarea.vue';
import InputI18n from '@/components/form/InputI18n.vue';
import InputImage from '@/components/form/InputImage.vue';
import InputEditor from '@/components/form/InputEditor.vue';
import InputRadio from '@/components/form/InputRadio.vue';
import InputCheckbox from '@/components/form/InputCheckbox.vue';
import InputOneCheckbox from '@/components/form/InputOneCheckbox.vue';
import SelectCountries from '@/components/form/SelectCountries.vue';
import SelectRegions from '@/components/form/SelectRegions.vue';

export default {
    languages,
    components: {
        InputText,
        InputI18n,
        InputImage,
        InputEditor,
        InputTextarea,
        InputRadio,
        InputCheckbox,
        InputOneCheckbox,
        SelectCountries,
        SelectRegions,
    },
    data() {
        return {
            currentLanguage: 'de',
            type: 'add',
            element: null,
        };
    },
    computed: {
        error() {
            return this.$store.state[this.$options.module].error;
        },
        errors() {
            return this.$store.state[this.$options.module].errors;
        },
        editElement() {
            if (typeof this.$route.params.id === 'undefined') {
                return null;
            }

            const id = parseInt(this.$route.params.id, 10);
            if (Number.isNaN(id) || id <= 0) {
                return null;
            }

            const element = this.$store.getters[`${ this.$options.module }/getById`](id);
            if (typeof element === 'undefined') {
                return null;
            }

            const elementWithDefault = merge({}, this.$options.emptyElement, element);
            if (this.$options.emptyChild) {
                elementWithDefault.items = elementWithDefault.items.map((item) => {
                    return merge(
                        {},
                        this.$options.emptyChild,
                        item,
                    );
                });
            }

            return elementWithDefault;
        },
    },
    async created() {
        await this.$store.dispatch(`${ this.$options.module }/list`);
        this.initData();
    },
    methods: {
        initData() {
            if (this.$route.name === `${ this.$options.module }.add`) {
                this.type = 'add';
                this.element = {
                    ...JSON.parse(JSON.stringify(this.$options.emptyElement)),
                };
                if (this.$options.emptyChild) {
                    this.element.items = [{
                        ...JSON.parse(JSON.stringify(this.$options.emptyChild)),
                    }];
                }
            } else if (this.$route.name === `${ this.$options.module }.edit`) {
                const element = this.editElement;
                if (element === null) {
                    this.actionBackToList('error_nonexistent');
                    return;
                }
                this.type = 'edit';
                this.element = merge(
                    {},
                    JSON.parse(JSON.stringify(this.$options.emptyElement), element),
                    JSON.parse(JSON.stringify(element)),
                );
            } else {
                this.actionBackToList('error_router');
            }
        },
        actionBackToList(message = null) {
            if (message === null) {
                this.$router.push({ name: this.$options.module });
            }
            this.$router.push({ name: this.$options.module, query: { m: message } });
        },
        actionChangeLang(currentLang) {
            this.currentLanguage = currentLang;
        },
        actionPublish() {
            this.element.state = 1;
            this.actionSave();
        },
        actionValidate() {
            return true;
        },
        async actionSave() {
            if (this.actionValidate()) {
                const action = (this.type === 'edit') ? 'update' : 'create';
                try {
                    await this.$store.dispatch(`${ this.$options.module }/${ action }`, this.element);
                    if (this.error === null) {
                        this.actionBackToList(`success_${ action }`);
                    } else {
                        this.popOpen(this.$t(`general.errors.form.${ this.error }`), 'error');
                    }
                } catch (err) {
                    if (process.env.NODE_ENV !== 'production') {
                        console.log(err);
                    }
                    this.actionBackToList('error_server');
                }
            }
        },
    },
};
